<template>
    <div>
        <Head><title>Revenue Share</title></Head>
        <h1 class="mb-8 text-3xl font-bold">Revenue Share</h1>
        <div class="flex  items-center justify-between mb-6">
            <search-filter :show-input="true" v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
                <label class="block text-gray-700">Project:</label>
                <select v-model="form.project" class="form-select mt-1 w-full">
                    <option v-for="project in projects" :key="project.id" :value="project.id">
                        {{ project.name }}
                    </option>
                </select>
                <template #dateFilter>
                    <date-picker v-model="form.date" :range="true" :time-picker="false"
                                 :enable-time-picker="false" input-class-name="dp-custom-input" :multi-calendars="2"
                                 :preset-ranges="presetRanges" auto-apply>
                    </date-picker>
                </template>
            </search-filter>
        </div>
        <Link class="btn-indigo mb-5" href="revenue-share/create">
            <span>Create</span>
            <span class="hidden md:inline">&nbsp;Add Share Ratio</span>
        </Link>
    </div>
    <Table :resource="revenue_share_data">

        <template #cell(actions)="{ item: share }">
            <a :href="`/revenue-share/details/${share.id}`"
               class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full">
                Details
            </a>
        </template>
    </table>


</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from "@/Shared/Pagination.vue";
import {Table} from "@protonemedia/inertiajs-tables-laravel-query-builder";
import {ref} from "vue";
import {
    endOfMonth,
    endOfYear,
    endOfYesterday,
    startOfMonth,
    startOfYear,
    startOfYesterday,
    subDays,
    subMonths, subYears
} from "date-fns";

export default {
    components: {
        Pagination,
        Head,
        Icon,
        Link,
        SearchFilter,
        Table
    },
    layout: Layout,
    props: {
        filters: Object,
        partners: Array,
        projects: Array,
        revenue_share_data: Object,
    },
    data() {
        return {
            form: {
                search: this.filters.search,
                role: this.filters.role,
                date: this.filters.date,
            },
            presetRanges: ref([
                {label: 'Today', range: [new Date(), new Date()]},
                {label: 'Yesterday', range: [startOfYesterday(), endOfYesterday()]},
                {label: 'Last 3 Days', range: [subDays(new Date(), 2), new Date()]},
                {label: 'Last 7 Days', range: [subDays(new Date(), 6), new Date()]},
                {label: 'This month', range: [startOfMonth(new Date()), new Date()]},
                {
                    label: 'Last month',
                    range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
                },
                {
                    label: 'Last 3 months',
                    range: [startOfMonth(subMonths(new Date(), 3)), new Date()],
                },
                {
                    label: 'Last 6 months',
                    range: [startOfMonth(subMonths(new Date(), 6)), new Date()],
                },
                {label: 'This year', range: [startOfYear(new Date()), new Date()]},
                {
                    label: 'Last year',
                    range: [startOfYear(subYears(new Date(), 1)), endOfYear(subYears(new Date(), 1))]
                },
                {
                    label: 'All Times',
                    range: [startOfYear(subYears(new Date(), 1)), new Date()]
                },
            ]),
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/revenue-share', pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
